import './sketchbook.css';
import { useState, useRef, useEffect } from 'react';

const pages = [
  { src: '/page1.png', alt: 'Page 1' },
  { src: '/page2.png', alt: 'Page 2' },
];

function Sketchbook() {
  const [currentPage, setCurrentPage] = useState(0);
  const touchStartX = useRef(null);
  const touchStartY = useRef(null);
  const pageRef = useRef(null);

  const prevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 0));
  const nextPage = () => setCurrentPage((prev) => Math.min(prev + 1, pages.length - 1));

  useEffect(() => {
    const el = pageRef.current;
    if (!el) return;

    const handleTouchStart = (e) => {
      touchStartX.current = e.touches[0].clientX;
      touchStartY.current = e.touches[0].clientY;
    };

    const handleTouchMove = (e) => {
      if (touchStartX.current === null) return;
      const dx = Math.abs(e.touches[0].clientX - touchStartX.current);
      const dy = Math.abs(e.touches[0].clientY - touchStartY.current);
      if (dx > dy) e.preventDefault();
    };

    const handleTouchEnd = (e) => {
      if (touchStartX.current === null) return;
      const diff = touchStartX.current - e.changedTouches[0].clientX;
      if (diff > 50) nextPage();
      else if (diff < -50) prevPage();
      touchStartX.current = null;
      touchStartY.current = null;
    };

    el.addEventListener('touchstart', handleTouchStart, { passive: true });
    el.addEventListener('touchmove', handleTouchMove, { passive: false });
    el.addEventListener('touchend', handleTouchEnd, { passive: true });

    return () => {
      el.removeEventListener('touchstart', handleTouchStart);
      el.removeEventListener('touchmove', handleTouchMove);
      el.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);

  return (
    <div className="Sketchbook">
      <button className="arrow" onClick={prevPage} disabled={currentPage === 0} aria-label="Previous page">↤</button>

      <div className="page" ref={pageRef}>
        <img src={pages[currentPage].src} alt={pages[currentPage].alt} />
        <p className="swipe-hint">
          <span className={`swipe-hint-arrow${currentPage === 0 ? ' faded' : ''}`}>←</span>
          {' swipe '}
          <span className={`swipe-hint-arrow${currentPage === pages.length - 1 ? ' faded' : ''}`}>→</span>
        </p>
      </div>

      <button className="arrow" onClick={nextPage} disabled={currentPage === pages.length - 1} aria-label="Next page">↦</button>
    </div>
  );
}

export default Sketchbook;
